<header class="oep-band">
  <div class="oep-band__top">
    <span class="oep-band__brand"><span class="oep-band__agu">AGU</span><span class="oep-band__rule" aria-hidden="true"></span><span class="oep-band__program">Outstanding Emerging Presenters</span></span>
    <div class="oep-band__right">
      <button type="button" class="oep-band__bell" [attr.aria-label]="BellLabel" [title]="BellLabel" (click)="OpenNotifications.emit()">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 8a6 6 0 1 0-12 0c0 5-2 6-2 6h16s-2-1-2-6"></path><path d="M10.3 19a2 2 0 0 0 3.4 0"></path></svg>
        @if (Unread > 0) { <span class="oep-band__count" aria-hidden="true">{{ Unread }}</span> }
      </button>
      <div class="oep-band__account" (keydown.escape)="CloseAccount()">
        <button type="button" class="oep-band__me" [attr.aria-expanded]="AccountOpen" aria-controls="oep-band-account" [attr.aria-label]="'Account menu for ' + Context.Me.FullName" (click)="ToggleAccount()">
          <span class="oep-band__initials" aria-hidden="true">{{ Context.Me.Initials }}</span><span class="oep-band__name" aria-hidden="true">{{ Context.Me.FullName }}</span>
        </button>
        @if (AccountOpen) {
          <div id="oep-band-account" class="oep-band__menu">
            @if (Host.CanReturnToHost) { <button type="button" (click)="ReturnToHost()">Back to MJ Explorer</button> }
            <button type="button" (click)="SignOut()">Sign out</button>
          </div>
        }
      </div>
    </div>
  </div>
  <button type="button" class="oep-band__menu-toggle" [attr.aria-expanded]="MenuOpen" aria-controls="oep-band-nav" (click)="MenuOpen = !MenuOpen">{{ MenuLabel }}</button>
  <nav id="oep-band-nav" class="oep-band__nav" [class.oep-band__nav--open]="MenuOpen" aria-label="OEP">
    @for (n of Nav; track n.View) {
      <button type="button" class="oep-band__tab" [class.oep-band__tab--on]="n.View === Active" [attr.aria-current]="n.View === Active ? 'page' : null" (click)="Pick(n)">
        {{ n.Label }}@if (n.Badge !== null) { <span class="oep-band__badge">{{ n.Badge }}</span> }
      </button>
    }
  </nav>
</header>
